export const DEFAULT_HEADER_HEIGHT = 72

export const getHeaderHeight = () => {
  if (typeof window === 'undefined') return DEFAULT_HEADER_HEIGHT
  return (
    document.getElementById('header__main')?.clientHeight ||
    DEFAULT_HEADER_HEIGHT
  )
}
